import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { SharedData, UserService } from '../../services/user.service';

import { Role } from '../../models/role';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RoleDetailComponent } from '../role-detail/role-detail.component';
import { RoleCreateComponent } from '../role-create/role-create.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-role',
    templateUrl: './role.component.html',
    styleUrls: ['./role.component.scss']
})
export class RoleComponent implements OnInit {
    dialogRef: MatDialogRef<RoleDetailComponent>;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    roles = [];
    displayedColumns: string[] = ['RoleId', 'RoleName', 'RoleActive', 'CreatedDate', 'ModifiedBy',  'edit'];
    dataSource = new MatTableDataSource<Role>();
    searching = true;
    searchValue = '';
    isCustomUiChange: boolean = false;
    private sharedDataSubscription: Subscription;

    constructor(private userService: UserService, private dialog: MatDialog) { 
        this.sharedDataSubscription = this.userService.sharedData$.subscribe((data: SharedData) => {
            this.isCustomUiChange = data.isCustomUiChange;
        });
    }

    ngOnInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        // Custom filter for global search
        this.dataSource.filterPredicate = (data: Role, filter: string) => {
        const dataStr = Object.keys(data).map(key => {
            const value = data[key];
            return value ? value.toString().toLowerCase() : '';
        }).join(' ');
        return dataStr.includes(filter);
        };
        this.getRoles();
    }

    ngOnDestroy(): void {
        this.sharedDataSubscription.unsubscribe();
    }

    applyFilter() {
        this.dataSource.filter = this.searchValue.trim().toLowerCase();
    }

    clearSearch() {
      this.searchValue = '';
      this.applyFilter();
    }

    private getRoles() {
        this.userService.getRoles().subscribe(data => {
            this.roles = data;
            this.dataSource.data = this.roles;
            this.searching = false;
        });
    }


    addNewRole() {
        let className=localStorage.getItem("themeName");
        const dialogCreate = this.dialog.open(RoleCreateComponent, {
            panelClass: className,
            data: { 
                isCustomUiChange: this.isCustomUiChange
            },
            disableClose: true
        });
        dialogCreate.afterClosed().subscribe(result => {
            this.getRoles();
        });
    }

    public handleClick(role: Role) {
        let className=localStorage.getItem("themeName");
        this.dialogRef = this.dialog.open(RoleDetailComponent,
            {
                data: {
                    dataKey: role
                },panelClass:className
            });

            this.dialogRef.afterClosed().subscribe(result => {
            this.getRoles();
        });
        /* this.router.navigate(['/roleDetail']); */
    }
}
